<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="b-u-transfer-deposit-detail"
    @beforeOpen="beforeOpen($event, close)"
    classDetail="transfer-deposit-detail"
    @beforeClose="beforeClose"
    @shortkeyAction="shortkeyAction"
    class="careceipt-detail"
  >
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide step-1"
        leftIcon="ic-guide"
        @click="guide"
        tooltipIconLeft="Hướng dẫn chức năng"
      />
      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".careceipt-detail"></ms-tour>
      <ms-button
        text="Phím tắt"
        tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide step-2"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />
      <div
        class="button icon24 setting-small mr-2"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'"></div>
      <a target="_blank" :href="linkHelp($ms.constant.Help.CAReceipt)">
        <div class="button icon24 ic-question mr-2" v-tooltip="'Trợ giúp'" shortkey-target="Help"></div>
      </a>
    </template>
    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="amount-text">Tổng tiền</div>
        <div class="central-title">
          <div class="title-control-group" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>
        <!-- Bên trên -->
        <div class="above-container flex-row" v-show="toggleAbove">
          <div class="above-left flex">
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label>Người nộp</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  :quickAddMulti="quickAddMultiItems"
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObject({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :data="accountingObjectCombo"
                  :columns="accountColumns"
                  :dropdownWidth="600"
                  :rules="[{name: $ms.constant.ValidateRule.ForceSelection}]"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                  :maxLength="255"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                  v-model="model.accounting_object_name"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  :quickAddMulti="quickAddMultiItems"
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObject({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :data="comboboxDataRemote.account"
                  :columns="accountColumns"
                  :dropdownWidth="600"
                  :rules="[{name: $ms.constant.ValidateRule.ForceSelection}]"
                  :queryMode="'remote'"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                  :remoteFilter="true"
                  :maxLength="255"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'account',
                      })
                  "
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                  v-model="model.accounting_object_name"
                ></ms-input>
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Địa chỉ">Địa chỉ</label>
              </div>
              <div class="control-right">
                <ms-input
                  class=""
                  v-model="model.accounting_object_address"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Lý do nộp">Lý do nộp</label>
              </div>
              <div
                class="control-right"
                :class="this.dbOptions?.HeightOption == 1 ? 'height-area-small' : 'height-area-big'"
              >
                <ms-textarea
                  v-model="model.journal_memo"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                  :rows="1"
                ></ms-textarea>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Kèm theo</label>
              </div>
              <div class="control-right">
                <ms-input
                  v-model="model.document_included"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>
          </div>
          <div class="above-right">
            <div
              class="seperator-line"
              :class="this.dbOptions?.HeightOption == 1 ? 'seperator-line-height-small' : ''"
            ></div>
            <div class="flex-row control-group mt-1">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày phiếu thu">Ngày PT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.ref_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                  @msChangeData="validateRefDate"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày hạch toán">Ngày HT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số phiếu thu">Số PT</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing"
                  v-model="model.ref_no"
                  :maxLength="20"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Bên dưới -->
        <div class="under-container flex1">
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></div>
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></div>
          <ms-resize-screen isFlex class="flex-column flex">
            <template v-slot:content-master>
              <div class="toolbar-grid flex-between">
                <div class="content-left">
                  <div class="item-tabs" :class="{active: selectedTab == 1}" @click="selectedTabHandler(1)">
                    Hạch toán
                  </div>
                  <div class="item-tabs" :class="{active: selectedTab == 2}" @click="selectedTabHandler(2)">
                    Thống kê
                  </div>
                  <div
                    v-if="useTA"
                    class="item-tabs"
                    :class="{active: selectedTab == 3}"
                    @click="selectedTabHandler(3)"
                  >
                    Thuế
                  </div>
                </div>
                <div class="flex-row flex-center">
                  <ms-checkbox 
                    v-if="isTaxReduction && (this.dbOptions?.TaxCalculationMethod == $ms.constant.TaxCalculationMethod.DirectMethod)"
                    label="Giảm 20% thuế GTGT theo Nghị quyết giảm thuế" 
                    v-model="model.is_tax_reduction"
                    :disabled="viewing"
                    class="mr-3"
                    />
                  <label class="label text-nowrap">Loại tiền</label>

                  <div class="ml-2 w100px">
                    <ms-combobox
                      :columns="currencyColumns"
                      valueField="currency_code"
                      displayField="currency_code"
                      ref="refCurrencyCode"
                      :data="comboboxDataRemote.currency"
                      v-model="model.currency_code"
                      :initText="model.currency_code"
                      @selected="selectCurrency"
                      @blur="assignValueCurrency"
                      :dropdownWidth="600"
                      :class="['input-editor', 'currency-combo']"
                      :queryMode="'remote'"
                      :remoteFilter="true"
                      @comboboxLoadData="onCurrencyComboboxLoadData"
                      :disabled="viewing"
                    ></ms-combobox>
                  </div>

                  <label
                    class="text-nowrap ml-2"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                    >Tỷ giá</label
                  >

                  <div
                    class="ml-2 w100px"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                  >
                    <ms-number
                      v-model="model.exchange_rate"
                      :formatType="$ms.constant.FormatType.ExchangeRate"
                      :disabled="viewing"
                      @onActionBlur="onActionBlur"
                      :max="999999"
                    ></ms-number>
                  </div>

                  <menu-wrapper class="topnav-widget-more-container ml-2" :maxHeight="200">
                    <template #menu-button="{toggleMenu}">
                      <ms-button
                        :disabled="viewing"
                        rightIcon="down-arrow-black"
                        text="Định khoản nhanh"
                        class="ml-2"
                        @click="toggleMenu"
                        :hasBorder="true"
                        type="outline-button circle-button btn-multi-action-detail"
                      />
                    </template>
                    <template #menu-content>
                      <menu-item
                        v-for="(item, index) in accountingActions"
                        :key="index"
                        :seperatorBottom="item.seperatorBottom"
                        @click="clickQuickAccounting(item.id)"
                        >{{ item.text }}</menu-item
                      >
                    </template>
                  </menu-wrapper>
                </div>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 1 || selectedTab == 2">
                <ms-grid-editor
                  :disabled="viewing"
                  :data="model.CAReceiptDetail"
                  v-model:list="model.CAReceiptDetail"
                  formId="careceipt-detail"
                  ref="refDetail"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggers"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configAccountingGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 3">
                <ms-grid-editor
                  formId="careceipt-detail"
                  :disabled="viewing"
                  :data="model.CAReceiptDetailTax"
                  v-model:list="model.CAReceiptDetailTax"
                  :ref="refDetailOther"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggerTaxs"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configTaxGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
            </template>
            <template v-slot:content-item>
              <div class="flex-column flex">
                <div class="toolbar-grid flex-between">
                  <div class="content-left">
                    <div class="item-tabs active">Hạch toán đồng thời</div>
                  </div>

                  <div class="flex-row flex-center">
                    <ms-button
                      type="icon-button"
                      leftIcon="update-down"
                      text="Cập nhật hạch toán đồng thời"
                      @click="generateParallel(true)"
                      :disabled="viewing"
                      class="update-btn"
                    />
                  </div>
                </div>
                <div class="flex d-flex">
                  <ms-grid-editor
                    formId="careceipt-detail"
                    :disabled="viewing"
                    :data="model.Parallels"
                    v-model:list="model.Parallels"
                    ref="refDetailParallel"
                    class="flex-box"
                    idField="ref_detail_id"
                    greyTitle
                    :columns="columnsDataParalell"
                    :propsData="propsDataParalell"
                    @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                    :footer="true"
                    @updateBusiness="changeDataBusiness"
                    :changeTriggers="changeTriggerParallels"
                    @onEditEventCellEditor="
                      (colIndex, rowIndex, $grid) => {
                        toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                      }
                    "
                    :name="'gridParallel'"
                    @copyDownRow="copyDownRow"
                    @copyActionClick="copyActionClick"
                    isCopyDataColumn
                    :lineBreak="this.dbOptions?.LineBreak ?? 1"
                    :configVoucherQuickEdit="configParallelGrid"
                    :isQuickEditVoucher="isQuickEditVoucher"
                    :itemRightClicks="itemRightClicks"
                    @afterRightClickAction="viewAccount(this)"
                  ></ms-grid-editor>
                </div>
              </div>
            </template>
          </ms-resize-screen>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
          <ms-button
            text="Cất"
            v-tooltip="'Cất (Ctrl + S)'"
            class="step-close"
            shortkey-target="Save"
            @click="commandClick($ms.constant.Command.SaveView)"
          ></ms-button>
          <ms-button
            text="Hoãn"
            type="btn-custom"
            class="mr-footer-btn"
            @click="commandClick($ms.constant.Command.Postpone)"
            v-if="!viewing"
            v-tooltip="'Hoãn (Ctrl + U)'"
            shortkey-target="Postpone"
          ></ms-button>
        </div>
        <div class="flex-row" v-if="viewing">
          <ms-button
            text="Sửa"
            class="mr-footer-btn step-8-unposted"
            title="Sửa"
            type="btn-custom"
            v-if="this.isShowEditAndPosted && !this.isFromCompareConvert"
            v-tooltip="'Sửa (Ctrl + E)'"
            shortkey-target="Edit"
            @click="clickEdit"
            :disabled="offlineReady"
          ></ms-button>

          <ms-button
            text="Ghi sổ"
            class="step-close"
            v-if="this.isShowEditAndPosted"
            v-tooltip="'Ghi sổ (Ctrl + G)'"
            shortkey-target="Posted"
            @click="commandClick($ms.constant.Command.Posted)"
            :disabled="offlineReady"
          ></ms-button>
          <!-- start -->
          <div class="flex-row" v-if="this.isShowUnPosted && isQuickEditVoucher" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              v-tooltip="'Cất (Ctrl + S)'"
              class="step-close"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>
            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              @click="commandClick($ms.constant.Command.Postpone)"
            ></ms-button>
          </div>
          <ms-button
            text="Sửa nhanh"
            title="Sửa nhanh"
            class="mr-footer-btn step-7-posted"
            type="btn-custom"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            shortkey-target="QuickEdit"
            @click="eventQuickEditVoucher"
          ></ms-button>
          <!-- end -->
          <ms-button
            text="Bỏ ghi"
            class="step-close"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            v-tooltip="'Bỏ ghi (Ctrl + B)'"
            shortkey-target="UnPosted"
            @click="commandClick($ms.constant.Command.UnPosted)"
          ></ms-button>
        </div>
        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            class="btn-opacity max-height pl-1"
            @click="refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View"
            v-tooltip="'Nạp (Ctrl + R)'"
            shortkey-target="Refresh"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-pos"
            classCustom="btn-opacity"
            @menuClick="clickItemHandle"
            isBtnFooterHelpFul
            :menuItems="buttonUtilities"
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>

          <div class="seperator-button"></div>

          <!-- Tạm thời disable nút in cho đến khi thi công chức năng In báo cáo -->
          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            class="max-height step-6-pos"
            classCustom="btn-opacity"
            isBtnFooterHelpFul
            @menuClick="printItemCLick"
            :menuItems="printMenu"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
            :disabled="!viewing"
            shortkey-target="Print"
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            class="btn-opacity max-height"
            :disabled="!viewing || isShowFromReport || stateApprove"
            @click="onApproveAction"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-unposted"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: $ms.constant.Command.Add})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
        </div>
        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            class="mr-1"
            shortkey-target="ArrowLeft"
            :disabled="!currentIndexBack"
            v-tooltip="'Trước'"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button
            text="Đóng"
            v-tooltip="'Đóng (Ctrl + Q)'"
            shortkey-target="Quit"
            type="btn-custom"
            @click="hide"
            class="mr-2"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import {ModuleCAReceipt} from '@/stores/moduleConst';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import {useCAReceiptDetailData} from './CAReceiptDetailData';
import {useCAReceiptDataCommon} from './CAReceiptDataCommon.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import {ModuleContext, ModuleAccountingObject} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import currencyAPI from '@/apis/di/currencyAPI.js';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useCurrencyShowColumn} from '@/commons/gridColumn/CurrencyShowColumn.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import {useQuickAccountingVoucher} from '@/setup/utilities/quickAccountingVoucher.js';
import RefType from '@/commons/wildcards/constants/RefType.js';
import {ref, getCurrentInstance, onMounted, computed, reactive, shallowRef} from 'vue';
import {useActionParallel} from '@/commons/gridColumn/ActionParallel.js';
import sASaleInvoiceAPI from '@/apis/sa/sASaleInvoiceAPI.js';
import commonFn from '@/commons/commonFunction.js';
import {useCAReceiptSaleDetailData} from '@/views/sell/cAReceiptSale/CAReceiptSaleDetailData.js';
import {showConfirm} from '@/commons/globalMessage';
import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import {useCachePurchasePurposeComboConfig} from '@/commons/combobox/cacheCombo/cachePurchasePurposeComboConfig.js';
import MsTour from '@/components/tour/MsTour.vue';
import {useCopyNewVoucher} from '@/views/utility/commons/copyNewVoucher.js';
import popupUtil from '@/commons/popupUtil';
import sAReceiptAPI from '@/apis/sa/sAReceiptAPI.js';
import sAElectronicTicketAPI from '@/apis/sa/sAElectronicTicketAPI.js';
import {useValidateBudgetSourceAccount} from '@/views/utility/commons/validateBudgetSourceAccount.js';
import msResizeScreen from '@/components/resize-wrapper/MsResizeScreen.vue';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import {collectionMonitor} from '@/setup/utilities/monitor';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MenuWrapper,
    MenuItem,
    MsTour,
    msResizeScreen,
  },
  extends: baseDetailVoucher,
  name: 'CAReceiptDetail',

  setup: () => {
    const titleCode = 'detail_popup_careceiptdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleCAReceipt;
    /** Cache lại param khi refresh */
    const isCacheParam = true;
    //Có sử dụng nghiệp vụ Thuế không
    const useTA = ref(false);
    // có hiển thị checkbox giảm 20% thuế GTGT
    const isTaxReduction = ref(true);

    onMounted(() => {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      if (dbOptions && typeof dbOptions === 'object') {
        useTA.value = dbOptions.UseTA;
      }
    });

    /**
     * Config sửa nhanh chứng từ
     */
    const configAccountingGrid = [
      'description', // diễn giải
      'note', //ghi chú
      'contract_no', //hợp đồng
      'topic_code', //đề tài
      'statistic_code', // mã thống kê
      'activity_name', // hoạt động
      'fund_code', //loại quỹ
      'is_source_before_year', // nguồn năm trước
      'fund_structure_name', //cơ cấu vốn
      'task_code', //nhiệm vụ
      'project_activity_id', //hoạt động dự án
      'project_expense_id', //khoản chi dự án
      'project_expense_code',
    ];

    const configTaxGrid = ['description', 'accounting_object_name', 'accounting_object_address', 'company_tax_code'];

    const configParallelGrid = ['description'];

    /**
     * Cấu hình ref grid để base đọc
     */
    proxy._gridDetails = {
      CAReceiptDetail: 'refDetail',
      //Chỗ này mặc định phải config Parallels ở vị trí thứ 2
      Parallels: 'refDetailParallel',
      CAReceiptDetailTax: 'refDetailOther',
    };

    let layoutTagDetail = ref('CAReceiptDetail');
    let layoutTagDetailOther = ref('CAReceiptDetailTax');
    const selectedTabHandler = value => {
      switch (value) {
        case 1:
          layoutTagDetail.value = 'CAReceiptDetail';
          currentLayout.value = 'CAReceiptDetail';
          break;
        case 2:
          layoutTagDetail.value = 'CAReceiptDetailSta';
          currentLayout.value = 'CAReceiptDetailSta';
          break;
        case 3:
          layoutTagDetailOther.value = 'CAReceiptDetailTax';
          currentLayout.value = 'CAReceiptDetailTax';
          break;
      }
      selectedTab.value = value;
    };

    // Validate tài khoản và nguồn
    const {onPosted, customUnPostedSuccess} = useValidateBudgetSourceAccount();

    const {projectColumns, bankColumns, accountColumns, currencyColumns} = useComboboxColumns();

    // Khởi tạo dữ liệu
    const {buttonUtilities, buttonPrints, columnParallel, comboboxLoadData, submitQuickAdd} = useCAReceiptDetailData();
    const taxDirectMethodValue = [0, 1, 2, 3, 5];
    const {
      comboboxDataRemote,
      toggleAbove,
      toggleAboveHandler,
      selectedTab,
      currentLayout,
      accountComboConfig,
      projectComboConfig,
      onAccountingObjectComboboxLoadData,
      accountComboMostDetailConfig,
      typeOfFundComboConfig,
      accountingObjectComboConfig,
      projectExpenseComboConfig,
    } = useCAReceiptDataCommon();

    const {cacheAccountDebitCombo, cacheAccountCreditCombo, cacheAccountTaxCreditCombo} = useCacheAccountComboConfig();
    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    cacheAccountTaxCreditCombo.modelValueField = 'tax_account';
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();

    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();

    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();

    const {
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetDetailItemComboConfig,
    } = useCacheBudgetItemComboConfig();

    const {cacheProjectComboConfig} = useCacheProjectComboConfig();
    const {cacheAccountingObjectComboConfig, accountingObjectCombo} = useCacheAccountingObjectComboConfig();

    const {cacheActivityComboConfig} = useCacheActivityComboConfig();

    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();

    const {cacheBankInfoComboConfig} = useCacheBankInfoComboConfig();

    const {cacheContractComboConfig} = useCacheContractComboConfig();
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();

    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();
    const {cachePurchasePurposeComboConfig} = useCachePurchasePurposeComboConfig();

    const subSystemCode = proxy.$ms.constant.SubSystemCode.CAReceipt;

    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      AccountingObject: {
        titleSearch: 'đối tượng',
        payload: {
          sort: 'is_employee,accounting_object_code',
        },
        module: ModuleAccountingObject,
        idField: 'accounting_object_id',
      },
    });

    // Cấu hình các field của grid
    const propsData = {
      //Số chứng từ gốc
      org_ref_no: {
        maxLength: 255,
      },
      //Ngày chứng từ gốc
      org_ref_date: {},
      //Số hóa đơn
      inv_no: {
        maxLength: 20,
      },
      //Ngày hóa đơn
      inv_date: {},
      //Loại hóa đơn
      inv_type: {
        enum: 'InvType',
        modelValueField: 'inv_type',
      },
      //Mẫu số hóa đơn
      invoice_form_number_code: {
        maxLength: 255,
      },
      //Ký hiệu hóa đơn
      inv_series: {
        maxLength: 255,
      },
      //Diễn giải
      description: {
        maxLength: 255,
      },
      //Tên đối tượng
      accounting_object_name: {
        maxLength: 255,
      },
      //TK nợ
      debit_account: cacheAccountDebitCombo,
      //TK có
      credit_account: cacheAccountCreditCombo,
      //Số tiền
      amount_oc: {
        max: proxy.$ms.constant.RangeOfNumber.Max,
      },
      //Nguồn
      budget_source_name: cacheBudgetSourceComboConfig,
      //Chương
      budget_chapter_code: cacheBudgetChapterComboConfig,
      //Loại
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      //Khoản
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      //Mục
      budget_item_code: cacheBudgetItemComboConfig,
      //Tiểu mục
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      //Tiết tiểu mục
      budget_detail_item_code: cacheBudgetDetailItemComboConfig,
      //Đối tượng
      accounting_object_code: accountingObjectComboConfig,
      //Số lượng
      quantity: {},
      //Đơn giá
      unitprice: {},
      //Định mức
      norm: {},
      //Tk ngân hàng, kho bạc
      bank_account: cacheBankInfoComboConfig,
      //Chương trình mục tiêu, dự án
      project_code: cacheProjectComboConfig,
      //Đề tài
      topic_code: cacheTopicComboConfig,
      //Hoạt động
      activity_id: {},
      //Tên hoạt động
      activity_name: cacheActivityComboConfig,
      //Mã dự phòng
      budget_provide_code: cacheBudgetProvideComboConfig,
      //Mã thống kê
      statistic_code: {},
      //Cấp phát
      method_distribute_name: {
        enum: 'MethodDistributeType',
        modelValueField: 'method_distribute_type',
      },
      //Nghiệp vụ
      cash_withdraw_type_name: {
        enum: 'CashWithDrawType',
        modelValueField: 'cash_withdraw_type_id',
      },
      //Ghi chú
      note: {
        maxLength: 255,
      },
      //Phí, lệ phí
      budget_fees_code: cacheBudgetFeesComboConfig,
      //Nguồn năm trước
      is_source_before_year: {},
      //Cơ cấu vốn
      fund_structure_name: cacheFundStructureComboConfig,
      //Nhiệm vụ
      task_code: cacheTaskComboConfig,
      //Hợp đồng
      contract_no: cacheContractComboConfig,
      //TK thuế
      tax_account: cacheAccountTaxCreditCombo,
      //Thuế suất
      tax_rate: {
        enum: 'TaxRateInventory',
        modelValueField: 'tax_rate',
      },
      //Nhóm ngành nghề
      industry_group_rate: {
        enum: 'TaxCalculationOccupation',
        modelValueField: 'industry_group_rate',
      },
      //Tiền thuế
      tax_amount: {
        min: proxy.$ms.constant.RangeOfNumber.Min,
        max: proxy.$ms.constant.RangeOfNumber.Max,
      },
      //Địa chỉ
      accounting_object_address: {
        maxLength: 255,
      },
      //Mã số thuế
      company_tax_code: {
        maxLength: 50,
      },
      //Hoạt động
      activity_name: cacheActivityComboConfig,
      //Mã thống kê
      statistic_code: cacheStatisticComboConfig,
      //Nhóm hàng hóa dịch vụ
      purchase_purpose_code: cachePurchasePurposeComboConfig,
      //Hành động
      rowAction: ['Insert', 'Delete'],
      //Gía tính thuế
      turn_over: {
        min: proxy.$ms.constant.RangeOfNumber.Min,
        max: proxy.$ms.constant.RangeOfNumber.Max,
      },
      //Tiền quy đổi
      amount: {
        min: proxy.$ms.constant.RangeOfNumber.MinAmount,
        max: proxy.$ms.constant.RangeOfNumber.MaxAmount,
      },
      project_expense_code: projectExpenseComboConfig,
      //Loại quỹ
      fund_code: cacheFundComboConfig,
    };

    // Cấu hình các feild của grid hạch toán
    const propsDataParalell = Object.assign({}, propsData, {amount_oc: {}});
    //Config quickAdd người nộp
    const quickAddMultiItems = ref([
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Khách hàng, nhà cung cấp',
      },
      {
        valueField: 'EmployeeDetail',
        displayField: 'Cán bộ',
      },
    ]);

    /**
     * Update value khi sửa 1 field trong grids
     * TPNAM 13.04.2022
     * Modified: TVDAT 17.07.2022
     */
    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);
      //custom switch case
      switch (dataField) {
        //Xử lý khi thay đổi thuế suất
        case 'tax_rate':
        case 'turn_over':
          let taxRate = $grid.dataView[rowIndex].tax_rate || 0;
          let turnOver = $grid.dataView[rowIndex].turn_over || 0;
          let taxAmountValue;
          if (taxRate == $grid.$ms.constant.TaxRateInventory.NoSelected) {
            taxAmountValue = 0;
          } else {
            taxAmountValue = (taxRate * turnOver) / 100;
          }
          callbackUpdateRow({tax_amount: taxAmountValue}, rowIndex);
          break;
        case 'accounting_object_code':
          callbackUpdateRow({
            accounting_object_name: metaData?.accounting_object_name,
            accounting_object_address: metaData?.address,
            company_tax_code: metaData?.company_tax_code,
          }, rowIndex);
        break;
        default:
          break;
      }
    };

    /**
     * Override gắn thêm dữ liệc mặc định khi mở form
     * TVDAT 20/07/2022
     */
    async function bindData(data) {
      if(data.ref_date > new Date(proxy.$ms.constant.FixValue.TaxReductionPeriod)){
        isTaxReduction.value = false;
        data.is_tax_reduction = false;
      }
      if (data.ref_id || proxy._formParam.mode == proxy.$ms.constant.FormState.Add) {
        //Tổng tiền
        data.total_amount = data.total_amount || 0;
        data.posted_date = data.posted_date || proxy.postedDate;
        data.ref_date = data.ref_date || proxy.postedDate;
        //Loại tiền, mặc định là tiền VND
        data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
        //Tỷ giá
        data.exchange_rate = data.exchange_rate || 1;
        currencyCode.value = data.currency_code;
        proxy.super('bindData', baseDetailVoucher, data);
        // sinh hạch toán đồng thời
        if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
          await proxy.generateParallel(true, true);
          assignDataEmptyToParallel(proxy);
        }
        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
        if (proxy.viewing) {
          if (proxy.model.is_posted) {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('posted') || x.state.includes('default'));
          } else {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('unposted') || x.state.includes('default'));
          }
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
        }
      }
    }

    /**
     * Ovrride để Gán lại tham số trước khi save
     * TPNAM 30.03.2022
     */
    function getSaveData(mode, action) {
      var data = proxy.super('getSaveData', baseDetailVoucher, mode, action);

      data.ref_type = proxy.$ms.constant.RefType.CAReceipt;
      data.ref_type_name = proxy.$t('i18nEnum.RefType.CAReceipt');
      if (data.IsInvoiceGenerateData) {
        let ListSaleInvoiceId = [];
        proxy.model.CAReceiptDetail.filter(x => x.state == 1).forEach(e => {
          if (e.ListSaleInvoiceId) {
            e.ListSaleInvoiceId.forEach(re => {
              if (!ListSaleInvoiceId.includes(re)) {
                ListSaleInvoiceId.push(re);
              }
            });
          }
        });
        data.ListSaleInvoiceId = ListSaleInvoiceId;
      }
      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.isSaveOffline = proxy?.offlineReady;
      if (data.isSaveOffline && !data.state) {
        data.state = proxy.$ms.constant.FormState.Add;
      }
      return data;
    }

    const {deleteVoucher} = useCAReceiptSaleDetailData();

    const {clickItemCopyVoucher} = useCopyNewVoucher(proxy, 'CAReceiptDetail');

    /**
     * Action click button Tiện ích
     * NXCHIEN 13.04.2022
     */
    const clickItemHandle = item => {
      switch (item.command) {
        //Thêm mới chứng từ hiện thời
        case proxy.$ms.constant.Command.Duplicate:
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          item.form = item.form ?? 'CAReceiptDetail';
          item.refType = item.refType ?? proxy.$ms.constant.RefType.CAReceipt;
          clickItemCopyVoucher(item);
          break;
        //Xóa chứng từ hiện thời
        case proxy.$ms.constant.Command.Delete:
          // proxy.delete(proxy.model);
          deleteVoucher(proxy.model);
          break;
        //Thêm mới
        case proxy.$ms.constant.Command.Add:
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          proxy.add({
            mode: proxy.$ms.constant.FormState.Add,
          });
          break;
        //Xem số dư tài khoản
        case proxy.$ms.constant.Command.ViewAccount:
          viewAccount(proxy);
          break;
        //Sao chép chứng từ
        case proxy.$ms.constant.Command.Copy:
          proxy.clickCopyVoucher();
          break;
        //Cất thành định khoản tự động mới
        case proxy.$ms.constant.Command.AddAutoBusiness:
          proxy.saveAsNewAutoBusiness();
          break;
        //Lấy biên lai
        case 'GetReceipt':
          getReceiptVoucher();
          break;
        case proxy.$ms.constant.Command.GetElectronicTicket:
          getElectronicTicket();
          break;
      }
      proxy.pushTrans(item.command);
    };

    //#region config ẩn hiện cột và sự kiện liên quan đến combo Loại tiền
    const {columnsDataParalell} = useCurrencyShowColumn(proxy, columnParallel);

    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      totalAmountComputed,
      assignValueCurrency,
      onActionBlur,
      currencyCode,
      isFirst,
    } = useCurrencyCombo(
      comboboxDataRemote,
      comboboxLoadData,
      proxy,
      'CAReceiptDetail',
      'Parallels',
      'CAReceiptDetailTax',
    );
    //#endregion

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * TVDAT 01/08/2022
     */
    function customColumns(columns) {
      isFirst.value = false;
      if (proxy.model.currency_code && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
        let amountColumn = columns.find(item => item.dataField == 'amount');
        if (amountColumn && !amountColumn.visible) {
          amountColumn.visible = true;
        }
        columns.forEach(item => {
          if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
        proxy.columnsDataParalell.forEach(item => {
          if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      }
    }
    /**
     * Thêm IgnoreFields theo dboption
     * TPNAM 21.05.2024
     */
    const getIgnoreFields = () => {
      if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DeductionMethod){
        return ['industry_group_rate']
      } else {
        return []
      }
    }
    /**
     * Override: Custom các cột khác theo dbOptions
     * TPNAM 21.05.2024
     */
    function applyColumnByDbOptionCustom(item, dbOptions) {
      switch (item.dataField) {
        // Số CT đối trừ
        case 'industry_group_rate':
          // Nếu PP khấu trừ thì không có cột Nhóm ngành nghề
          if (dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DeductionMethod) {
            item.visible = false;
          }
          break;
        default:
          break;
      }
    }

    const {
      changeDataBusinessCommon, //Cập nhật dữ liệu 1 dòng khi sửa dòng dữ liệu trên grid
      defaultData, //Giá trị mặc định trong Danh mục TK ngầm định
      getDataDefault, // Lấy dữ liệu mặc định trong Danh mục TK ngầm định
      toggleAboveHandlerGrid, // mặc định trong Danh mục và trong DBOption,
      copyDownRow,
      copyActionClick,
      assignDataEmptyToParallel,
      bindDefaultData,
    } = useActionGridEditor(proxy);

    const {
      onBlurActionDatePicker, // sự kiện input Ngày Phiếu thu
      selectedAccountingObject, // sự kiện khi chọn cán bộ/KH, NCC
      viewAccount,
    } = useInforCommons();

    /**
     * Định khoản nhanh
     * NXCHIEN 10.07.2022
     */
    const {refType, clickQuickAccounting, accountingActions, saveAsNewAutoBusiness} = useQuickAccountingVoucher({
      gridDetails: proxy._gridDetails,
    });
    /**
     * Config tùy chỉnh giao diện
     * NXCHIEN 08.07.2022
     */
    const getConfigLayout = () => {
      return {
        layouts: [
          {tag: 'CAReceiptDetail', name: 'Hạch toán'},
          {tag: 'CAReceiptDetailSta', name: 'Thống kê'},
          {tag: 'CAReceiptDetailTax', name: 'Thuế', ignoreFields: proxy.getIgnoreFields()},
        ],
      };
    };
    /**
     * Custom gọi hàm sinh dữ liệu
     * NXCHIEN 05.07.2022
     */
    function customVoucherLoadData(result) {
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsGenerateData &&
        (proxy.editMode === proxy.$ms.constant.FormState.Add || proxy.editMode === proxy.$ms.constant.FormState.Edit)
      ) {
        Object.assign(result, {
          Id: proxy._formParam.data.ref_id,
          ParamModeAdd: JSON.stringify({
            RefTypeKey: proxy.$ms.constant.RefType.CAReceipt,
          }),
          IsSyncData: proxy._formParam.data.IsSyncData,
          action: 'DataVoucher',
        });
      } else {
        proxy.super('customVoucherLoadData', baseDetailVoucher, result);
      }
    }

    refType.value = RefType.CAReceipt; // gán refType theo form

    getDataDefault(proxy.$ms.constant.RefType.CAReceipt);
    /**
     * Gán dữ liệu mặc định vào grid
     * TVDAT 19.07.2022
     */
    function customDefaultData($grid, me, rowIndex) {
      //Tài khoản thuế
      if (defaultData.value && defaultData.value.allow_default_setting) {
        $grid.dataView[rowIndex].tax_account = defaultData.value.default_tax_account_id;
      }
      //Địa chỉ
      if (me.model.accounting_object_address) {
        $grid.dataView[rowIndex].accounting_object_address = me.model.accounting_object_address;
      } else {
        $grid.dataView[rowIndex].accounting_object_address = '';
      }
      //Mã số thuế
      if (me.model.company_tax_code) {
        $grid.dataView[rowIndex].company_tax_code = me.model.company_tax_code;
      } else {
        $grid.dataView[rowIndex].company_tax_code = '';
      }
      //Đối tượng khác
      if (me.model.accounting_object_name) {
        $grid.dataView[rowIndex].accounting_object_name = me.model.accounting_object_name;
      } else {
        $grid.dataView[rowIndex].accounting_object_name = '';
      }
      //Loại hóa đơn
      $grid.dataView[rowIndex].inv_type = me.$ms.constant.InvType.InvoiceGTGT;
      // Nhóm ngành nghề
      if(this.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DirectMethod){
        $grid.dataView[rowIndex].industry_group_rate = me.$ms.constant.TaxCalculationOccupation.ConstructionNotIncludeMaterials;
      }
    }

    const {configColumnParalell} = useActionParallel();

    /**
     * Override Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * TVDAT 29.07.2022
     */
    function getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return configColumnParalell;
    }

    /**
     * Validate số tiền
     * nmtuan4 11.8.2022
     */
    function validateAmount(detail, keyValue) {
      const me = proxy;
      let mes = proxy.super('validateAmount', baseDetailVoucher, detail, keyValue);

      if (mes && Object.keys(mes).length > 0) {
        return mes;
      }

      let parallels = proxy.model.Parallels.filter(
        x => x.state != proxy.$ms.constant.ModelState.Empty && x.state != proxy.$ms.constant.ModelState.Delete,
      );
      if (Array.isArray(parallels) && parallels.length > 0) {
        for (let item of parallels) {
          if (!item.amount && !item.amount_oc) {
            mes = {
              content: 'Giá trị hạch toán phải khác 0.',
              type: 3,
              title: 'Ghi sổ không thành công',
            };
            return mes;
          }
        }
      }

      return mes;
    }

    /**
     * Xử lý bind data khi sinh chứng từ từ hóa đơn
     * NNLINH 13.09.2022
     */
    async function beforeBindData() {
      const me = proxy;
      //Mặc định khi thêm mới ko có số HĐ chỉ khi sinh ct mới có số hóa đơn.
      if (proxy.editMode === proxy.$ms.constant.FormState.Add) {
        proxy.model.inv_no = null;
        proxy.model.inv_date = null;
      }
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsInvoiceGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });

        //Trường hợp sinh từ hóa đơn
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        // me.model.sale_invoice_id = me.model.ref_id;
        me.model.ref_id = commonFn.generateUUID();
        me.model.ref_type = proxy._formParam.refType;
        bindDataWithInvoiceGenerate();
      } else if (
        proxy._formParam &&
        proxy._formParam.lstRefIdSelect &&
        proxy._formParam.isReceiptGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        let payload = {
          isGroup: proxy._formParam.isGroup,
          refIds: proxy._formParam.lstRefIdSelect,
          refType: proxy.model.ref_type,
        };
        //Lấy dữ liệu biên lai sinh chứng từ
        let dataGen = await sAReceiptAPI.getDataGenerateReceipt(payload);
        BindDataGenerateReceipt(dataGen);
      } else if (
        //sinh từ vé điện tử
        proxy._formParam &&
        proxy._formParam.lstRefIdSelect &&
        proxy._formParam.isTicketGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        let payload = {
          refIds: proxy._formParam.lstRefIdSelect,
          refType: proxy.model.ref_type,
        };
        //Lấy dữ liệu biên lai sinh chứng từ
        let dataGen = await sAElectronicTicketAPI.getDataGenerateTicket(payload);
        BindDataGenerateReceipt(dataGen);
      } else if (
        //Sinh chứng từ xử lý chênh lệch Bảng kê kiểm quỹ
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.isFundInventory &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        await beforeBindDataFundInventory(proxy._formParam.data);
      } else {
        proxy.super('beforeBindData', baseDetailVoucher);
      }
    }

    /**
     * Hàm bindData khi sinh ct xử lý chênh lệch bảng kê kiểm quỹ
     * NNLINH 16.08.2023
     */
    async function beforeBindDataFundInventory(dataGenerate) {
      const me = proxy;
      // Lấy lại dữ liệu autoID...
      let data = await proxy.loadData('New', {
        mode: proxy.$ms.constant.FormState.Add,
      });
      //master
      me.model = dataGenerate;
      me.model.ref_no = data.ref_no;
      me.model.ref_date = proxy.postedDate;
      me.model.Parallels = [];
      me.model.is_fund_inventory = true;
      me.model.fund_inventory_ref_id = proxy._formParam.fund_inventory_ref_id;
      me.model.ref_type = data.ref_type;
      me.model.posted_date = proxy.postedDate;
      currencyCode.value = dataGenerate.currency_code;

      //Bind lại hình thức cấp phát, nghiệp vụ
      me.model.CAReceiptDetail.forEach(e => {
        e.ref_id = me.model.ref_id;
        //#region Gắn lại thông tin MLNS ngầm định
        // Nguồn
        if (me.dbOptions.DefaultBudgetSourceID) {
          e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
          e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
          // lấy thêm DefaultBudgetSourceGroupPropertyType
          e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
        }

        // Chương
        if (me.dbOptions.DefaultBudgetChapterCode) {
          e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
          e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
        }

        // Loại
        if (me.dbOptions.DefaultBudgetKindItemCode) {
          e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
          e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
        }

        // Khoản
        if (me.dbOptions.DefaultBudgetSubKindItemCode) {
          e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
          e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
        }

        // nghiệp vụ
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
          e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }
        // Loại quỹ
        if (me.dbOptions.DefaultFundID) {
          e.fund_id = me.dbOptions.DefaultFundID;
          e.fund_code = me.dbOptions.DefaultFundCode;
        }
        //#endregion
      });

      await proxy.generateParallel(true, true);
      // xử lý gán tham chiếu
      setVoucherReferenceInfo(dataGenerate.VoucherReferences);
    }

    /***
     * Hàm lấy mapping dữ liệu với dữ liệu của hóa đơn
     * NNLINH 16.09.2022
     */
    async function bindDataWithInvoiceGenerate() {
      const me = proxy;

      //Lấy danh sách tk con chi tiết nhất từ tk cha truyền vào
      let listAcc = await sASaleInvoiceAPI.getChildAccount(proxy.$ms.constant.AccountNumber.SaleInvoice);
      // Lấy tk có chi tiết nhất
      let creditAcc = listAcc.filter(e => e.account == '531').map(e => e.account_detail)[0];
      //Lấy tk nợ chi tiết nhất
      let debitAcc = listAcc.filter(e => e.account == '1111').map(e => e.account_detail)[0];
      //Lấy tk thuế chi tiết nhất
      let taxAcc = listAcc.filter(e => e.account == '33311').map(e => e.account_detail)[0];
      //Bind dữ liệu master
      me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
      me.model.exchange_rate = 1;
      if (!me.model.inv_date) {
        me.model.inv_date = proxy.postedDate;
      }
      me.model.posted_date = me.model.inv_date;
      me.model.ref_date = me.model.inv_date;
      if (me.model.accounting_object_name) {
        me.model.journal_memo = 'Bán hàng cho {0}'.format(me.model.accounting_object_name);
        // DVMINH case cắt đi đoạn này để không bị dài quá ký tự
        if (me.model.journal_memo.length > 255) {
          me.model.journal_memo = me.model.journal_memo.substring(0, 255);
        }
      }
      //Khởi tạo dữ liệu grid
      me.model.CAReceiptDetail = [];
      me.model.CAReceiptDetailTax = [];
      me.model.Parallels = [];
      me.model.Details.forEach(e => {
        //Bind dữ liệu cho tab hạch toán


        let newCAReceipt = {
          ref_id: me.model.ref_id,
          ref_detail_id: commonFn.generateUUID(),
          amount: e.amount - e.discount_amount,
          amount_oc: e.amount - e.discount_amount,
          debit_account: debitAcc,
          credit_account: creditAcc,
          description: e.description,
          accounting_object_code: me.model.accounting_object_code,
          accounting_object_id: me.model.accounting_object_id,
          state: 1,
        };
        // HMDuc2: Nếu tính thuế PP trực tiếp thì - với tiền thuế 
        if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DirectMethod){
          newCAReceipt = {
           ref_id: me.model.ref_id,
           ref_detail_id: commonFn.generateUUID(),
           amount: e.amount - e.discount_amount - e.tax_amount,
           amount_oc: e.amount - e.discount_amount - e.tax_amount,
           debit_account: debitAcc,
           credit_account: creditAcc,
           description: e.description,
           accounting_object_code: me.model.accounting_object_code,
           accounting_object_id: me.model.accounting_object_id,
           state: 1,
         };
        }

        if (e.ListSaleInvoiceId) {
          newCAReceipt.ListSaleInvoiceId = e.ListSaleInvoiceId.map(x => x);
        } else {
          newCAReceipt.ListSaleInvoiceId = [];
        }
        me.model.CAReceiptDetail.add(newCAReceipt);
        // nếu có thuế suất
        if (e.tax_amount && e.tax_amount != 0) {
          let newCAReceiptTax = {
            ListSaleInvoiceId: [],
            ref_id: me.model.ref_id,
            ref_detail_id: commonFn.generateUUID(),
            amount: e.tax_amount,
            amount_oc: e.tax_amount,
            debit_account: debitAcc,
            credit_account: taxAcc,
            description: e.description,
            accounting_object_code: me.model.accounting_object_code,
            accounting_object_id: me.model.accounting_object_id,
            state: 1,
          };

          // HMDuc2: 22/05/2024 Bind thêm dữ liệu nhóm ngành nghề
          if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DirectMethod){
            newCAReceiptTax['industry_group_rate'] = taxDirectMethodValue.includes(e?.tax_rate) ? e?.tax_rate : "";
          }
           // HMDuc2: Nếu tính thuế PP trực tiếp thì sinh dòng dữ liệu ở tab thuế và không có dòng thuế ở tab hoạch toán
          if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DirectMethod){
            // HMDUC2: Nếu là như lập nhiều từ hóa đơn thì không bind các thông tin mấu số, ký hiệu, số hóa đơn, ngày hóa đơn theo tài liệu
            if(!proxy._formParam.hasOwnProperty('isCreateFromMulti') && !proxy?._formParam?.isCreateFromMulti ){
              newCAReceiptTax.inv_date = proxy.model?.inv_date;
              newCAReceiptTax.inv_no = proxy.model?.inv_no;
              newCAReceiptTax.inv_series = proxy.model?.inv_series;
              newCAReceiptTax.inv_type_code = proxy.model?.inv_type_code;
              newCAReceiptTax.inv_type = proxy.model?.inv_type;
            }
            me.model.CAReceiptDetailTax.add(newCAReceiptTax);
          }else{
            me.model.CAReceiptDetail.add(newCAReceiptTax);
          }
        }
      });
      me.model.CAReceiptDetail.forEach(e => {
        //#region Gắn lại thông tin MLNS ngầm định
        // Nguồn
        if (me.dbOptions.DefaultBudgetSourceID) {
          e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
          e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
          // lấy thêm DefaultBudgetSourceGroupPropertyType
          e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
        }

        // Chương
        if (me.dbOptions.DefaultBudgetChapterCode) {
          e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
          e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
        }

        // Loại
        if (me.dbOptions.DefaultBudgetKindItemCode) {
          e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
          e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
        }

        // Khoản
        if (me.dbOptions.DefaultBudgetSubKindItemCode) {
          e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
          e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
        }

        // nghiệp vụ
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
          e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }
        // Loại quỹ
        if (me.dbOptions.DefaultFundID) {
          e.fund_id = me.dbOptions.DefaultFundID;
          e.fund_code = me.dbOptions.DefaultFundCode;
        }
        //#endregion
      });
    }
    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    /**
     * Override sự kiện khi đóng form
     * mở lại form hóa đơn khi sinh chứng từ
     * NNLINH 19.09.2022
     */
    function beforeClose(e) {
      if (proxy._formParam.options && typeof proxy._formParam.options.submitData === 'function') {
        proxy._formParam.options.submitData();
      } else {
        proxy.super('beforeClose', baseDetailVoucher, e);
      }
    }

    /**
     * Hàm click button sửa
     * NNLINH 21.09.2022
     */
    async function clickEdit() {
      // check quyền Sửa (vqphong - 12/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);

      let payload = {
        id: proxy.model.ref_id,
        type: 2,
      };
      let data = await sASaleInvoiceAPI.checkDataReference(payload);
      let message;
      //nếu có mã hóa đơn thì thông báo cảnh báo
      if (data && data.ListInvoiceReference) {
        //hiện cảnh báo
        let refNo = '';
        //Lấy danh sách mã hóa đơn liên quan
        if (data && data.ListInvoiceReference && data.ListInvoiceReference.length) {
          refNo = data.ListInvoiceReference.map(x => {
            return (
              (x.inv_form_number == null ? '' : '{0} - '.format(x.inv_form_number)) +
              (x.inv_series == null ? '' : '{0} - '.format(x.inv_series)) +
              (x.inv_no == null ? '' : '{0}'.format(x.inv_no))
            );
          }).join('; ');
        }
        if (data.is_receipt) {
          message = 'Chứng từ phiếu thu đã lập biên lai <span class="color-blue">{0}</span>. Sau khi sửa bạn vui lòng vào cập nhật các biên lai trên để dữ liệu được chính xác. Bạn có muốn sửa không?'.format(
            refNo,
            proxy.model.ref_no,
          );
        } else if (data.is_ticket) {
          message = 'Chứng từ phiếu thu đã lập vé điện tử <span class="color-blue">{0}</span>. Sau khi sửa bạn vui lòng vào cập nhật các vé điện tử trên để dữ liệu được chính xác. Bạn có muốn sửa không?'.format(
            refNo,
            proxy.model.ref_no,
          );
        } else {
          message = 'Chứng từ phiếu thu đã lập hóa đơn <span class="color-blue">{0}</span>. Sau khi sửa chứng từ này, bạn phải vào cập nhật lại các hóa đơn trên cho đúng. Bạn có muốn sửa không?'.format(
            refNo,
          );
        }
        showConfirm(message, 'Sửa phiếu thu').then(answer => {
          if (answer) {
            proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
          }
        });
      }
      //Nếu ko có reference thì chuyển mode sửa
      else {
        proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
      }
    }

    /**
     * Hàm xử lý sau khi cất
     * gắn lại hiển thị đã lập hóa đơn
     * NNLINH 10.10.2022
     */
    function afterSubmitModeView(result, param) {
      if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsInvoiceGenerateData) {
        result.IsInvoiceGenerateData = true;
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sASaleInvoice/updatedPosted', result.ListSaleInvoiceId);
      }
      ///12.04.2023 nnlinh bổ sung cập nhập lại màn hình danh sách biên lai
      if (proxy._formParam && proxy._formParam.isReceiptGenerateData) {
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sAReceipt/updatedPosted', result.ListSAReceiptId);
      }

      ///19.09.2023 nnlinh bổ sung cập nhập lại màn hình danh sách vé điện tử
      if (proxy._formParam && proxy._formParam.isTicketGenerateData) {
        //Update lại hạch toán màn hình danh sách
        proxy.$store.dispatch('sAElectronicTicket/updatedPosted', result.ListSATicketId);
      }
      proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
    }
    // Gửi report lên BE
    //nbtin - 26.10.22
    function getCustomReportParams(reportId) {
      let me = this;
      let param = {
        reportId: reportId,
        ref_type: proxy.$ms.constant.RefType.CAReceipt,
        ref_id: proxy.model.ref_id,
      };
      return param;
    }

    /**
     * custom thêm 1 số trường khi copy cột
     * TVDAT 09/11/2022
     */
    function copyDownRowExtend(
      objAssign,
      metaData,
      column,
      $grid,
      lastIndex,
      rowIndex,
      isShowCombo,
      callbackUpdateRow,
    ) {
      switch (column.dataField) {
        //Xử lý khi thay đổi thuế suất
        case 'tax_rate':
          let currentTaxRate = objAssign.tax_rate;
          for (let i = rowIndex; i <= lastIndex; i++) {
            if (currentTaxRate == $grid.$ms.constant.TaxRateInventory.NoSelected) {
              $grid.dataView[i].tax_amount = 0;
            } else {
              $grid.dataView[i].tax_amount = commonFunction.roundDecimalDbOption(
                proxy.$ms.constant.DbOptionKey.CurrencyDecimalDigits,
                (currentTaxRate * ($grid.dataView[i].turn_over || 0)) / 100,
              );
            }
          }
          break;
        //Xử lý khi thay đổi giá tính thuế
        case 'turn_over':
          let turnOver = objAssign.turn_over;
          for (let i = rowIndex; i <= lastIndex; i++) {
            let taxRate = $grid.dataView[i].tax_rate || 0;
            if (taxRate == $grid.$ms.constant.TaxRateInventory.NoSelected) {
              $grid.dataView[i].tax_amount = 0;
            } else {
              $grid.dataView[i].tax_amount = commonFunction.roundDecimalDbOption(
                proxy.$ms.constant.DbOptionKey.CurrencyDecimalDigits,
                (taxRate * turnOver) / 100,
              );
            }
          }
          break;
        case 'quantity':
        case 'amount':
        case 'amount_oc':
          const metaDataTracking = {
            tracking: {
              newVal: objAssign[column.dataField],
            },
          };
          const direction = lastIndex > rowIndex ? -1 : 1;
          while (lastIndex != rowIndex + direction) {
            proxy.changeDataBusiness($grid, column, lastIndex, metaDataTracking, callbackUpdateRow);
            lastIndex += direction;
          }
          break;
        default:
          break;
      }
    }
    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.step-1',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        key: 1,
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.step-2',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.setting-small',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.ic-question',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },
      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Thêm nội dung thu tiền mặt`,
      },
      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Xóa nội dung thu tiền mặt`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Nhấn Cất để lưu thông tin`,
      },
      {
        target: '.step-5-pos',
        header: {
          title: 'Tiện ích',
        },
        state: ['posted', 'unposted'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ mới, Xem số dư tài khoản,...',
      },
      {
        target: '.step-6-pos',
        header: {
          title: 'Chức năng In',
        },
        state: ['posted', 'unposted'],
        content: `Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô`,
      },
      {
        target: '.step-7-posted',
        header: {
          title: 'Sửa nhanh',
        },
        state: ['posted'],
        content: `Thực hiện sửa một số thông tin chung trên chứng từ`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Bỏ ghi',
        },
        state: ['posted'],
        content: `Bỏ ghi sổ chứng từ để sửa hoặc xóa chứng từ`,
      },
      {
        target: '.step-7-unposted',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['unposted'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-8-unposted',
        header: {
          title: 'Sửa',
        },
        state: ['unposted'],
        content: `Sửa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Ghi sổ',
        },
        state: ['unposted'],
        content: `Ghi sổ chứng từ hiện thời`,
      },
    ]);

    /**
     * Hàm xử lý lấy biên lai
     * NNLINH 06.04.2023
     */
    function getReceiptVoucher() {
      //Lấy danh sách các biên lai đã lập trên chứng từ -> loại bỏ khi chọn trên form chọn biên lai
      let lstReceiptId = [];
      let detail = proxy.model?.CAReceiptDetail;
      if (detail.length) {
        detail.forEach(x => {
          if (x.state != 3 && x.state != 4) {
            lstReceiptId = lstReceiptId.concat(x.SAReceiptIds);
          }
        });
      }
      popupUtil.show('GetReceiptDataPopup', {
        refType: RefType.CAReceipt,
        lstReceiptId: lstReceiptId,
        options: {
          submit: data => {
            if (data) {
              BindDataGenerateReceipt(data);
            }
          },
        },
      });
    }

    /**
     * Lấy vé điện tử
     * NNLINH 12.09.2023
     */
    function getElectronicTicket() {
      //Lấy danh sách các biên lai đã lập trên chứng từ -> loại bỏ khi chọn trên form chọn biên lai
      let lstTicketId = [];
      let detail = proxy.model?.CAReceiptDetail;
      if (detail.length) {
        detail.forEach(x => {
          if (x.state != 3 && x.state != 4 && x.SATicketIds != null && x.SATicketIds != undefined) {
            lstTicketId = lstTicketId.concat(x.SATicketIds);
          }
        });
      }
      popupUtil.show('GetElectronicTicketDataPopup', {
        refType: proxy.$ms.constant.RefType.CAReceipt,
        idIgnore: lstTicketId,
        options: {
          submit: data => {
            if (data) {
              BindDataGenerateReceipt(data);
            }
          },
        },
      });
    }

    /**
     * Hàm bind dữ liệu cho chứng từ khi sinh từ biên lai
     * NNLINH 10.04.2023
     */
    function BindDataGenerateReceipt(data) {
      //Gắn lại thông tin master
      //Chỉ gắn thông tin master mode add
      if (proxy.editMode === proxy.$ms.constant.FormState.Add) {
        //Gắn lại thông tin đối tượng
        proxy.model.accounting_object_id = data.accounting_object_id;
        proxy.model.accounting_object_code = data.accounting_object_code;
        proxy.model.accounting_object_name = data.accounting_object_name;
        proxy.model.accounting_object_address = data.accounting_object_address;
        if (data.ref_date) {
          //Gắn lại ngày ht. ngày ct
          proxy.model.ref_date = data.ref_date;
          proxy.model.posted_date = data.posted_date;
        }
        //Gắn lại thông tin vé điện tử
        proxy.model.IsElectronicTicket = data?.IsElectronicTicket;
      }

      //Gắn dữ liệu detail
      if (data.CAReceiptDetail && data.CAReceiptDetail.length) {
        // lấy ra index lớn nhất
        let indexMax =
          proxy.model.CAReceiptDetail.findLastIndex(x => x.state != proxy.$ms.constant.ModelState.Empty) || 0;

        let restIndex = proxy.model.CAReceiptDetail.length - 1 - indexMax;

        // thêm data.CAReceiptDetail.length - restIndex dòng nữa
        let length = data.CAReceiptDetail.length - restIndex;
        for (let i = 0; i < length; i++) {
          proxy.$refs['refDetail'].addRow(
            proxy.$refs['refDetail'].datax.length,
            proxy.model.CAReceiptDetail.length + i,
            true,
          );
        }

        for (let i = 0; i < data.CAReceiptDetail.length; i++) {
          let item = data.CAReceiptDetail[i];
          item.amount_oc = item.amount;
          item.ref_id = proxy.model.ref_id;
          Object.keys(item).forEach(x => {
            if (!item[x]) {
              delete item[x];
            }
          });

          // lấy default cho data.gridDetail.length dòng
          bindDefaultData(proxy.$refs['refDetail'], proxy, indexMax + i + 1); // refDetail là key bảng hạch toán
          Object.assign(proxy.model.CAReceiptDetail[indexMax + i + 1], {
            ...item,
          });
        }
      }

      //Gắn dữ liệu tab thuế
      if (data.CAReceiptDetailTax && data.CAReceiptDetailTax.length) {
        // lấy ra index lớn nhất
        let indexMax =
          proxy.model.CAReceiptDetailTax.findLastIndex(x => x.state != proxy.$ms.constant.ModelState.Empty) || 0;

        let restIndex = proxy.model.CAReceiptDetailTax.length - 1 - indexMax;

        // thêm data.CAReceiptDetail.length - restIndex dòng nữa
        let length = data.CAReceiptDetailTax.length - restIndex;
        for (let i = 0; i < length; i++) {
          proxy.$refs['refDetailOther'].addRow(
            proxy.$refs['refDetailOther'].datax.length,
            proxy.model.CAReceiptDetailTax.length + i,
            true,
          );
        }

        for (let i = 0; i < data.CAReceiptDetailTax.length; i++) {
          let item = data.CAReceiptDetailTax[i];
          item.amount_oc = item.amount;
          item.ref_id = proxy.model.ref_id;
          Object.keys(item).forEach(x => {
            if (!item[x]) {
              delete item[x];
            }
          });

          // lấy default cho data.gridDetail.length dòng
          // bindDefaultData(proxy.$refs['refDetailOther'], proxy, indexMax + i + 1); // refDetail là key bảng hạch toán
          Object.assign(proxy.model.CAReceiptDetailTax[indexMax + i + 1], {
            ...item,
          });
        }
      }

      let lstSAReceiptId = [];
      proxy.model?.CAReceiptDetail.forEach(x => {
        if (x.state != 3 && x.state != 4 && x.SAReceiptIds) {
          lstSAReceiptId = lstSAReceiptId.concat(x.SAReceiptIds);
        }
      });
      proxy.model.ListSAReceiptId = lstSAReceiptId;

      let lstSATicketId = [];
      proxy.model?.CAReceiptDetail.forEach(x => {
        if (x.state != 3 && x.state != 4 && x.SATicketIds) {
          lstSATicketId = lstSATicketId.concat(x.SATicketIds);
        }
      });

      if (proxy.model.ListSATicketId?.length) {
        proxy.model.ListSATicketId = proxy.model.ListSATicketId.concat(lstSATicketId);
      } else {
        proxy.model.ListSATicketId = lstSATicketId;
      }
    }
    /**
     * nthien4 case TH cất lỗi khi mất mạng
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        proxy.super('saveError', baseDetailVoucher, error, param, action);
      }
    }

    const changeTriggers = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'amount_oc',
      'debit_account',
      'credit_account',
      'budget_source_name',
      'amount',
      'budget_detail_item_code',
      'accounting_object_code',
      'credit_account',
      'debit_account',
      'project_expense_code',
      'quantity',
    ]);

    const changeTriggerTaxs = shallowRef([
      'project_code',
      'accounting_object_code',
      'tax_rate',
      'tax_amount',
      'amount_oc',
      'amount',
      'turn_over',
      'budget_detail_item_code',
    ]);

    const changeTriggerParallels = shallowRef([
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_source_name',
      'amount_oc',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
    ]);

    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_no, ref_type, is_generate_invoice }) => ({ ref_id, ref_no, ref_type, is_generate_invoice }))];
    }

    /**
     * Lấy tên model lưu dữ liệu grid thuế
     */
    function getTaxKeyModel() {
      return "CAReceiptDetailTax"
    }
    /**
     * Hàm ẩn hiện checkbox giảm 20% GTGT khi sửa ngày HT
     * TPNAM 22.05.2024
     */
    function validateRefDate(newVal){
      if(newVal > new Date(proxy.$ms.constant.FixValue.TaxReductionPeriod)){
        isTaxReduction.value = false;
        proxy.model.is_tax_reduction = false;
      }
      else{
        isTaxReduction.value = true;
      }
    }

    /**
     * 
     * @param command Ghi đè hàm gửi lên mcp
     * @param isPrintVoucher 
     * @param report 
     */
    function pushTrans(command, isPrintVoucher = false, report) {
      if(proxy.dbOptions?.TaxCalculationMethod == proxy.$ms.constant.TaxCalculationMethod.DirectMethod && command === proxy.$ms.constant.Command.SaveView) {
        const {pushTrans: pushTransFunc} = collectionMonitor();
        pushTransFunc(proxy.$ms.constant.Command.CreateVoucherWithTaxDirect, `Lập chứng từ Thu tiền mặt theo phương pháp tính thuế trực tiếp`, 'CAReceiptDetail');
      } 
      proxy.super('pushTrans', baseDetailVoucher, command, isPrintVoucher, report);
    }

    return {
      pushTrans,
      titleCode,
      viewAccount,
      changeTriggers,
      changeTriggerTaxs,
      changeTriggerParallels,
      module, // module form cha
      toggleAbove, // Value đóng mở thu gọn
      toggleAboveHandler, // Action thu gọn form
      selectedTab, // Value hiển thị tab
      currentLayout,
      selectedTabHandler, // Xử lý active tab các grid chi tiết
      buttonUtilities, // Button tiện tích
      buttonPrints, // Button in
      // Cấu hình Field trong grid
      columnParallel,
      propsData, // Chứa config các field trong grid
      currencyAPI,
      comboboxLoadData, //  Call API lấy dữ liệu combo
      submitQuickAdd,
      comboboxDataRemote, // Object chưa data của các combo
      // column combo
      projectColumns,
      bankColumns,
      accountColumns,
      currencyColumns,
      columnsDataParalell,
      clickItemHandle,
      changeDataBusiness,
      getSaveData, // override lấy tham số để save
      bindData,
      //xử lý sự kiện select trên combo
      selectedAccountingObject,
      selectCurrency,
      totalAmountComputed,
      onActionBlur,
      onCurrencyComboboxLoadData,
      onAccountingObjectComboboxLoadData,
      layoutTagDetail,
      layoutTagDetailOther,
      customColumns,
      toggleAboveHandlerGrid,
      accountComboConfig,
      defaultData,
      onBlurActionDatePicker,
      clickQuickAccounting,
      accountingActions,
      saveAsNewAutoBusiness,
      customVoucherLoadData,
      accountComboMostDetailConfig,
      getConfigLayout,
      getDataDefault,
      refType,
      customDefaultData,
      projectComboConfig,
      quickAddMultiItems,
      assignValueCurrency,
      propsDataParalell,
      getParallelModel,
      //tên router form danh sách khi đóng sẽ quay lại
      backRouter: '/cash/careceipt',
      currencyCode,
      useTA,
      typeOfFundComboConfig,
      validateAmount,
      beforeBindData,
      beforeClose,
      clickEdit,
      afterSubmitModeView,
      getCustomReportParams,
      copyDownRow,
      copyDownRowExtend,
      copyActionClick,
      steps,
      subSystemCode,
      quickSearchParam,
      isCacheParam,
      onPosted,
      customUnPostedSuccess,
      configAccountingGrid,
      configTaxGrid,
      configParallelGrid,
      disabledDelete,
      stepsDynamic,
      accountingObjectCombo,
      saveError,
      DBStartDateString: proxy.DBStartDateString,
      getParamDeleteDetail,
      getTaxKeyModel,
      getIgnoreFields,
      applyColumnByDbOptionCustom,
      isTaxReduction,
      validateRefDate,
      taxDirectMethodValue
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    accountingObjectCombo() {
      return this.accountingObjectCombo
        .sort(function (a, b) {
          return a.accounting_object_code - b.accounting_object_code;
        })
        .sort(function (a, b) {
          return a.is_employee - b.is_employee;
        });
    },
  },
};
</script>

<style lang="scss">
.careceipt-detail {
  @import './CAReceiptDetail.scss';
  .height-area-small {
    .ms-textarea-item {
      height: $input-height-custom-small !important;
      padding: 2px 6px !important;
    }
  }
  .height-area-big {
    .ms-textarea-item {
      height: $input-height-custom-big !important;
      padding: 4px 6px !important;
    }
  }
}
</style>
